// extracted by mini-css-extract-plugin
export default {"container":"NoActivityMessage_container__iEAmr"};